import { httpClient } from '@/services/http/httpClient'

type RemoveUsersParams = {
  evaluatorId: string
  ideaId: string
  stepId: string
}

export async function removeEvaluatorReplicate({
  evaluatorId,
  ideaId,
  stepId,
}: RemoveUsersParams): Promise<void> {
  await httpClient.delete(
    `/ideas/evaluations/evaluators/${evaluatorId}/replicate`,
    {
      data: {
        ideaId,
        stepId,
      },
    },
  )
}
